import React from "react";
import { forgotpassword } from "../../../../../common/lib/forgotpassword";
import CustomCarousel from "../../../carousel/theme11/CustomCarousel";
import { noLeadingSpace } from "../../../../lib/utils/regex_cheat_sheet";

export default class VendorForgotPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      vendorCode: "",
      vendorCodeError: "",
      userName: "",
      userNameError: "",
      generalError: "",
      onClickLoginLoader: false,
      showResetPassword: false,
      newPassword: "",
      newPasswordError: "",
      confirmPassword: "",
      confirmPasswordError: "",
      resetSuccess: false,
      resetExpired: false,
      prefillEmail: "",
    };
  }

  handleChangeEmail = (e) => {
    // Not used for vendor flow
  };

  // handleBlurEmail = (e) => {
  // Not used for vendor flow

  handleChangeVendorCode = (e) => {
    if (!noLeadingSpace.test(e.target.value) && e.target.value !== "") {
      return;
    }
    const value = e.target.value;
    let error = "";
    if (!value.trim()) {
      error = "Please enter vendor code.";
    } else if (value[0] === " ") {
      error = "Vendor Code should not start with space.";
    }
    this.setState({ vendorCode: value, vendorCodeError: error });
  };

  handleBlurVendorCode = (e) => {
    const value = e.target.value;
    let error = "";
    if (!value.trim()) {
      error = "Please enter vendor code.";
    } else if (value[0] === " ") {
      error = "Vendor Code should not start with space.";
    }
    this.setState({ vendorCodeError: error });
  };

  handleChangeUserName = (e) => {
    if (!noLeadingSpace.test(e.target.value) && e.target.value !== "") {
      return;
    }
    const value = e.target.value;
    let error = "";
    if (!value.trim()) {
      error = "Please enter username.";
    } else if (value[0] === " ") {
      error = "User Name should not start with space.";
    }
    this.setState({ userName: value, userNameError: error });
  };

  handleBlurUserName = (e) => {
    const value = e.target.value;
    let error = "";
    if (!value.trim()) {
      error = "Please enter username.";
    } else if (value[0] === " ") {
      error = "User Name should not start with space.";
    }
    this.setState({ userNameError: error });
  };

  validatePassword = (value) => {
    if (!value) return "New Password is required.";
    if (value.length < 8 || value.length > 20)
      return "Password must be 8-20 characters.";
    if (!/[A-Z]/.test(value))
      return "Password must have at least one uppercase letter.";
    if (!/[0-9]/.test(value)) return "Password must have at least one number.";
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(value))
      return "Password must have at least one special character.";
    if (/\s/.test(value)) return "Password must not contain spaces.";
    return "";
  };

  handleChangeNewPassword = (e) => {
    const value = e.target.value;
    const error = this.validatePassword(value);
    this.setState({ newPassword: value, newPasswordError: error });
    // Also validate confirm password if already entered
    if (this.state.confirmPassword) {
      this.handleChangeConfirmPassword({
        target: { value: this.state.confirmPassword },
      });
    }
  };

  handleChangeConfirmPassword = (e) => {
    const value = e.target.value;
    let error = this.validatePassword(value);
    if (!error && value !== this.state.newPassword) {
      error = "Re-enter New Password should be a match to New Password";
    }
    this.setState({ confirmPassword: value, confirmPasswordError: error });
  };
  // };

  handleSubmit = async () => {
    // Vendor forgot password request
    const { vendorCode, vendorCodeError, userName, userNameError } = this.state;
    if (!vendorCode || vendorCodeError || !userName || userNameError) {
      this.setState({
        vendorCodeError:
          vendorCodeError || (!vendorCode ? "Please enter vendor code." : ""),
        userNameError:
          userNameError || (!userName ? "Please enter username." : ""),
      });
      return;
    }
    this.setState({ generalError: "", onClickLoginLoader: true });
    try {
      // Replace with actual API call for vendor forgot password
      const forgotPassReq = { code: vendorCode, email: userName };
      const res = await forgotpassword(forgotPassReq);
      if (res && res.status === true && res.message && res.message !== "") {
        // Show reset password form
        this.setState({
          onClickLoginLoader: false,
          showResetPassword: true,
          prefillEmail: res.email || "",
          resetExpired: false,
        });
        this.props.handlers.setPopupType({
            popupCompoenet: "login",
            popupPage: "RequestConfirmed",
          });
      } else if (res && res.errorType === "vendor") {
        this.setState({
          generalError: "Vendor Code is invalid.",
          onClickLoginLoader: false,
        });
      } else if (res && res.errorType === "user") {
        this.setState({
          generalError: "User Name is invalid.",
          onClickLoginLoader: false,
        });
      } else if (res && res.errorType === "expired") {
        this.setState({
          generalError: "Reset Password link has expired.",
          onClickLoginLoader: false,
          resetExpired: true,
        });
      } else {
        this.setState({
          generalError: "User Does Not Exist.",
          onClickLoginLoader: false,
        });
      }
    } catch (error) {
      this.setState({
        generalError: "Failed to send request.",
        onClickLoginLoader: false,
      });
    }
  };

  handleBackToLogin = () => {
    if (
      this.props.handlers &&
      typeof this.props.handlers.setPopupType === "function"
    ) {
      this.props.handlers.setPopupType("vendor_login");
      this.props.handlers.setPopupType({
        popupCompoenet: "vendor_login",
        popupPage: "vendor_login",
      });
    }
  };

  render() {
    const { styles, PromotionBannerCss, isMobile } = this.props;
    const {
      vendorCode,
      vendorCodeError,
      userName,
      userNameError,
      generalError,
      onClickLoginLoader,
      showResetPassword,
      newPassword,
      newPasswordError,
      confirmPassword,
      confirmPasswordError,
      resetSuccess,
      resetExpired,
      prefillEmail,
    } = this.state;
    // --- New banner logic using PromotionBanner ---
    const imageLoader = ({ src }) => {
      const url = `/shared/api/media/${src}`;

      return url;
    };

    const CustomPrevArrow = () => (
      <img src="/images/arrow_2-01.svg" width={20} height={20} alt="Previous" />
    );
    const CustomNextArrow = () => (
      <img src="/images/back-arrow.png" width={20} height={20} alt="Next" />
    );

    const customResponsive = {
      desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
      tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2,
        slidesToSlide: 2,
      },
      mobile: { breakpoint: { max: 464, min: 0 }, items: 1, slidesToSlide: 1 },
    };

    const banners = this.props?.siteData?.data?.signin?.banners;

    return (
      <div className={styles.main_content}>
        {/* Left side - Promotional Banner (dynamic) */}
        <div className={styles.login_banner}>
          <CustomCarousel
            banners={banners}
            imageLoader={imageLoader}
            cssstyles={PromotionBannerCss}
            arrows={false}
            dots={true}
            autoplay={false}
            imageKey="upload_image"
            prevArrow={"/images/back-arrow.png"}
            nextArrow={"/images/back-arrow.png"}
            responsive={customResponsive}
          />
          {isMobile ? (
            <div className={styles.banner_left_arrrow}>
              <img src="images/te_Left_Arrow.svg" alt="arrow" />
            </div>
          ) : null}
        </div>

        {/* Right side - Vendor Forgot Password Form */}
        <div className={styles.login_section}>
          <div className={`${styles.login_form} ${styles.forgot_form}`}>
            <div className={styles.form_header}>
              <h3>Forgot Password</h3>
              <div className={styles.form_subtitle}>
                <span>Don’t worry, happens to all of us.</span>
                <span>Enter your details below to recover your password</span>
              </div>
              {generalError && (
                <div className={styles.error_message} id="error-message">
                  <div className={styles.error_icon}>
                    <img src="images/te_Invalied.svg" alt="Invalid icon" />
                  </div>
                  <span>{generalError}</span>
                </div>
              )}
            </div>

            {!showResetPassword && !resetExpired && (
              <>
                <div
                  className={`${styles.form_group} ${styles.form_forgot_group}`}
                >
                  <label htmlFor="vendorCode">Vendor Code</label>
                  <div className={styles.input_container}>
                    <input
                      type="text"
                      id="vendorCode"
                      placeholder="Enter Vendor Code"
                      className={`${styles.normal_input} ${vendorCodeError ? styles.input_error : ""
                        }`}
                      value={vendorCode}
                      onChange={this.handleChangeVendorCode}
                      onBlur={this.handleBlurVendorCode}
                    />
                    {vendorCodeError && (
                      <div className={styles.error_text} id="vendorCode-error">
                        {vendorCodeError}
                      </div>
                    )}
                  </div>
                </div>
                <div
                  className={`${styles.form_group} ${styles.form_forgot_group}`}
                >
                  <label htmlFor="userName">User Name</label>
                  <div className={styles.input_container}>
                    <input
                      type="text"
                      id="userName"
                      placeholder="Enter User Name"
                      className={`${styles.normal_input} ${userNameError ? styles.input_error : ""
                        }`}
                      value={userName}
                      onChange={this.handleChangeUserName}
                      onBlur={this.handleBlurUserName}
                    />
                    {userNameError && (
                      <div className={styles.error_text} id="userName-error">
                        {userNameError}
                      </div>
                    )}
                  </div>
                </div>
                <button
                  className={`${styles.login_btn} ${onClickLoginLoader ? "loading" : ""
                    }`}
                  onClick={this.handleSubmit}
                >
                  <span>Submit</span>
                  <img src="images/te_Arrow_right.svg" alt="arrow" />
                </button>
                <div className={styles.register_link}>
                  <span
                    className={styles.back_to_login}
                    onClick={this.handleBackToLogin}
                  >
                    Back to Login
                  </span>
                </div>
              </>
            )}

            {showResetPassword && !resetSuccess && (
              <>
                <div
                  className={`${styles.form_group} ${styles.form_forgot_group}`}
                >
                  <label htmlFor="newPassword">Enter New Password</label>
                  <div className={styles.input_container}>
                    <input
                      type="password"
                      id="newPassword"
                      placeholder="Enter New Password"
                      className={`${styles.normal_input} ${newPasswordError ? styles.input_error : ""
                        }`}
                      value={newPassword}
                      onChange={this.handleChangeNewPassword}
                    />
                    {newPasswordError && (
                      <div className={styles.error_text} id="newPassword-error">
                        {newPasswordError}
                      </div>
                    )}
                  </div>
                </div>
                <div
                  className={`${styles.form_group} ${styles.form_forgot_group}`}
                >
                  <label htmlFor="confirmPassword">Re-enter New Password</label>
                  <div className={styles.input_container}>
                    <input
                      type="password"
                      id="confirmPassword"
                      placeholder="Re-enter New Password"
                      className={`${styles.normal_input} ${confirmPasswordError ? styles.input_error : ""
                        }`}
                      value={confirmPassword}
                      onChange={this.handleChangeConfirmPassword}
                    />
                    {confirmPasswordError && (
                      <div
                        className={styles.error_text}
                        id="confirmPassword-error"
                      >
                        {confirmPasswordError}
                      </div>
                    )}
                  </div>
                </div>
                <button
                  className={`${styles.login_btn} ${onClickLoginLoader ? "loading" : ""
                    }`}
                  onClick={async () => {
                    // Validate before submit
                    const newPasswordError = this.validatePassword(newPassword);
                    const confirmPasswordError =
                      this.validatePassword(confirmPassword) ||
                      (confirmPassword !== newPassword
                        ? "Re-enter New Password should be a match to New Password"
                        : "");
                    if (newPasswordError || confirmPasswordError) {
                      this.setState({ newPasswordError, confirmPasswordError });
                      return;
                    }
                    this.setState({
                      onClickLoginLoader: true,
                      generalError: "",
                    });
                    // Replace with actual API call for reset password
                    try {
                      // Simulate API call
                      // const res = await resetVendorPassword({ vendorCode, userName, newPassword });
                      // if (res && res.status === true) {
                      //   this.setState({ resetSuccess: true, onClickLoginLoader: false });
                      //   // Send password changed email here
                      // } else {
                      //   this.setState({ generalError: res.message || 'Failed to reset password.', onClickLoginLoader: false });
                      // }
                      this.setState({
                        resetSuccess: true,
                        onClickLoginLoader: false,
                      });
                    } catch (error) {
                      this.setState({
                        generalError: "Failed to reset password.",
                        onClickLoginLoader: false,
                      });
                    }
                  }}
                >
                  <span>Reset Password</span>
                  <img src="images/te_Arrow_right.svg" alt="arrow" />
                </button>
              </>
            )}

            {resetSuccess && (
              <div className={styles.form_header}>
                <h3>Password Reset Confirmed</h3>
                <div className={styles.form_subtitle}>
                  <span>Your password has been changed successfully.</span>
                  <span>
                    An email has been sent to your registered email id.
                  </span>
                </div>
                <button
                  className={styles.login_btn}
                  onClick={() => {
                    if (
                      this.props.handlers &&
                      typeof this.props.handlers.setPopupType === "function"
                    ) {
                      this.props.handlers.setPopupType("vendor_login", {
                        prefillEmail,
                      });
                    }
                  }}
                >
                  <span>Login Now</span>
                  <img src="images/te_Arrow_right.svg" alt="arrow" />
                </button>
              </div>
            )}

            {resetExpired && (
              <div className={styles.form_header}>
                <h3>Reset Password link has expired</h3>
                <div className={styles.form_subtitle}>
                  <span>
                    The reset password link is valid for 1 hour. Please initiate
                    Forgot Password again to get a new link.
                  </span>
                </div>
                <button
                  className={styles.login_btn}
                  onClick={() =>
                    this.setState({
                      showResetPassword: false,
                      resetExpired: false,
                    })
                  }
                >
                  <span>Try Again</span>
                  <img src="images/te_Arrow_right.svg" alt="arrow" />
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
